<template>
  <div
    class="operation-report-show-footer w-full flex justify-center items-center"
    :style="cssVariables"
  >
    <footer-edit v-show="isEditingReport" />
    <footer-read v-show="!isEditingReport" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("operationReport");
import FooterRead from "./FooterRead";
import FooterEdit from "./FooterEdit";
import {
  // formatDateTime,
  // notifyDeleteSuccess,
  // notifyDeleteFailed,
  // pushReportList,
  // pushEditScreen,
  isEditingReport,
} from "@/utils/operations";

export default {
  name: "OperationReportShowFooter",
  components: {
    FooterRead,
    FooterEdit,
  },
  props: {
    cssVariables: {
      type: Object,
      default: () => ({
        "--footer-height": "100px",
      }),
    },
  },

  computed: {
    ...mapGetters({
      // isEditing: "isEditing",
    }),
    isEditingReport() {
      return isEditingReport(this);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_variables.scss";
.operation-report-show-footer {
  height: var(--footer-height); // override this value in parent component

  background-color: $theme-background;

  --show-body-min-width: 960px;
  --show-body-max-width: 1216px;

  min-width: var(--show-body-min-width);
  max-width: var(--show-body-max-width);
}
</style>
